import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { FAQ_TYPES, SWAL_SETTINGS } from "../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as faqService from "../../services/faq.services";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../common/customeditor";

const FaqEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [saveType, setSaveType] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("sidebar_link_faq"),
      url: "/admin/cms/faq-management/faq/list/1",
    },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    faqService.Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response?.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const validationSchema = Yup.object().shape({
    question: Yup.string().required(t("label_question_error")).test("no-spaces", "label_question_error", (value) => value.trim()),
    answer: Yup.string().required(t("label_answer_error")).test("no-spaces", "label_answer_error", (value) => value.trim()),
    type: Yup.string().required(t("label_type_error")).test("no-spaces", "label_type_error", (value) => value.trim()),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      question: showdefault && showdefault.question ? showdefault.question : "",
      answer: showdefault && showdefault.answer ? showdefault.answer : "",
      type: showdefault && showdefault.type ? showdefault.type : FAQ_TYPES.APP_FEATURES,
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      const id = params.id;
      let formData = new FormData();
      // formData.append("o_id", params.id);
      formData.append("question", values.question);
      formData.append("answer", values.answer);
      formData.append("type", values.type || FAQ_TYPES.APP_FEATURES);


      faqService.Edit(formData, id)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/cms/faq-management/faq/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          globalLoader(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          console.log("error ====> ", error);
        });
    },
  });
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    {t("btn_edit")} {t("sidebar_link_faq")}
                  </h6>
                </div>
                <div className="row row-sm">
                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("label_question")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="question"
                      id="question"
                      type="text"
                      placeholder="Enter the question"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.question}
                      className="form-control"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="question" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-12 text-center form-group d-none">
                    <label htmlFor="type" className="text-left d-flex">
                      {t("label_type")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <div className=" select-down-arrow">
                      <select
                        name="type"
                        id="type"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.type}
                        className="form-control" >

                        <option value="">{t("input_select_text")}</option>
                        {Object.values(FAQ_TYPES).map((value, i) => {
                          return (
                            <option key={i} value={value}>
                              {value
                                .replace(/_/g, " ") // Replace underscores with spaces
                                .toLowerCase() // Convert to lowercase
                                .replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <span className="text-danger d-flex text-left">
                      <CustomError name="type" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-12 text-center form-group">
                    <label
                      htmlFor="answer"
                      className="text-left d-flex"
                    >
                      {t("label_answer")}:
                      <span className="requirestar">*</span>{" "}
                    </label>

                    <textarea
                      name="answer"
                      id="answer"
                      type="text"
                      placeholder="Enter the answer"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.answer}
                      className="form-control"
                      rows={5}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="answer" form={formik} />
                    </span>
                  </div>

                  <div className="mt-5">
                    <button
                      onClick={() => {
                        setSaveType("Save");
                      }}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save")}
                    </button>
                    <button
                      onClick={() => {
                        setSaveType("");
                      }}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save_exit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      onClick={() => navigate('/admin/cms/faq-management/faq/list/1')}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default FaqEdit;
